var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgImageAsset(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 24,
    viewBox: "0 0 30 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.265 4.036a.535.535 0 00-.167.127c-.084.086-.084.15-.096 7.715-.006 7.565-.006 7.623.078 7.755.048.075.131.15.191.167.066.023 3.901.04 10.646.04 9.756 0 10.545-.006 10.652-.069a.421.421 0 00.162-.161c.065-.138.065-15.246 0-15.384a.421.421 0 00-.162-.161c-.107-.063-.896-.069-10.67-.063-5.807.005-10.592.017-10.634.034zm20.593 6.255v5.41l-3.136-3.018-3.137-3.019h-.418l-3.351 3.226c-1.852 1.782-3.376 3.23-3.4 3.23-.018 0-.77-.7-1.66-1.558-1.566-1.506-1.631-1.557-1.78-1.557a.626.626 0 00-.252.046c-.048.023-.705.632-1.452 1.345l-1.362 1.31V4.888h19.954v5.404h-.006z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.04 6.41c-1.159.238-2.049 1.066-2.34 2.175-.07.265-.081.406-.064.811.018.422.035.546.14.839.157.433.325.71.651 1.047.617.648 1.43.969 2.373.93a3.027 3.027 0 001.39-.39c.372-.213.93-.782 1.128-1.154.541-1.013.471-2.156-.192-3.068a3.074 3.074 0 00-3.086-1.19z"
  })));
}

export default __webpack_public_path__ + "fba20a14e4fdde833d96b151d2272319.svg";
export { SvgImageAsset as ReactComponent };